;(function($, window, document){
    window.MailTo = Me.view.extend({
        options: {
        },

        initialize: function() {
            if(this.$el.attr('data-name') && this.$el.attr('data-domain')){
                this.$el.attr('href', 'mailto:' + this.$el.attr('data-name') + '@' + this.$el.attr('data-domain'));
            }
        }
    });
}(jQuery, window, document));
